import { App, getServerSideProps } from 'map-search'
import { useEffect } from 'react'
import { searchPageView } from 'tag-manager/page_view'

const Search = (props) => {
  useEffect(() => {
    searchPageView()
  }, [])

  return <App userGeolocation={props.userGeolocation} />
}

export { getServerSideProps }
export default Search
